//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            item: {
                vendor: {}
            },
            payment: {},
            voided: false,
            show: false
        };
    },
    created: function created() {
        Event.$on('view-ap-invoice', this.viewAPInvoice);
        Event.$on('refresh-invoices', this.refreshInvoices);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('view-ap-invoice');
        Event.$off('refresh-invoices');
    },

    methods: {
        viewAPInvoice: function viewAPInvoice(item) {
            var $el = this;
            Object.assign(this.$data, this.$options.data());
            $el.show = true;
            $el.$children[0].$data.showModal = true;
            axios.get('/prototype/accounting/accounts-payable/invoice/' + item.id).then(function (response) {
                $el.item = response.data.invoice;
                $el.payment = response.data.payment;
            });
        },
        refreshInvoices: function refreshInvoices() {
            Event.$emit('close-full-modal');
            Event.$emit('refresh-ap-invoices');
        },
        voidInvoice: function voidInvoice() {
            Event.$emit('confirm-delete', this.item, '/prototype/accounting/accounts-payable/invoice/void', 'refresh-invoices', 'Are you sure you want to void this invoice?', 'YES', true);
        },
        checkAttachment: function checkAttachment(attachment) {
            return attachment.includes('https://') ? attachment : process.env.MIX_AWS_URL + attachment;
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/invoices/ViewInvoice.vue
// module id = 3JxC
// module chunks = 0 1